import axios from 'axios';

const API_BASE_URL = 'https://zaki-app.hawiyat.cloud/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // sends HttpOnly cookies automatically
});

// Request interceptor
api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// Response interceptor - handles expired tokens
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip refresh if already retried or if it's auth endpoints
    const isAuthEndpoint = 
      originalRequest.url.includes('/token/') ||
      originalRequest.url.includes('/logOut/') ||
      originalRequest.url.includes('/current-user/');

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isAuthEndpoint
    ) {
      originalRequest._retry = true;

      try {
        // Try to refresh token
        // HttpOnly refresh cookie sent automatically
        await api.post('/token/refresh/');
        
        // Retry original request
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed → logout
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export const login = async (email, password) => {
  const response = await api.post('/token/', { email, password });
  return response.data;
};

export const refreshToken = async () => {
  const response = await api.post('/token/refresh/');
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/logOut/');
  localStorage.removeItem('user');
  return response.data;
};

export const register = async (userData) => {
  const payload = {
    email: userData.email,
    password: userData.password,
    role: userData.role,
  };

  if (userData.role === 'CANDIDATE') {
    payload.first_name = userData.firstName;
    payload.last_name = userData.secondName;
  } else if (userData.role === 'COMPANY') {
    payload.company_name = userData.companyName;
  }

  const response = await api.post('/registration/', payload);
  return response.data;
};

export const activateAccount = async (uidb64, token) => {
  const response = await api.get(`/activate/${uidb64}/${token}/`);
  return response.data;
};

export const googleAuth = async (googleToken, role) => {
  const response = await api.post('/auth/google/', { token: googleToken, role });
  return response.data;
};

export default api;